import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import BookingCta from "./BookingCta";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services & Rates" },
  { to: "/about", label: "About Dorothy" },
  { to: "/contact", label: "Contact" },
];

export function Wordmark({ light = false }) {
  return (
    <span className="leading-none">
      <span className={`block font-serif text-4xl font-bold tracking-tight md:text-5xl ${light ? "text-primary-foreground" : "text-primary"}`}>
        Dorothy Read
      </span>
      <span className={`mt-1.5 block text-xs font-semibold uppercase tracking-[0.4em] ${light ? "text-secondary" : "text-accent"}`}>
        Healing
      </span>
    </span>
  );
}

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50 border-b border-border bg-background/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-6 py-4">
        <Link to="/" data-testid="header-wordmark" aria-label="Dorothy Read Healing - home" className="shrink-0">
          <Wordmark />
        </Link>

        <nav aria-label="Main navigation" className="hidden items-center gap-1 lg:flex">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.to === "/" ? "home" : item.to.slice(1)}`}
              className={({ isActive }) =>
                `rounded-full px-4 py-3 text-sm font-medium transition-colors duration-200 ${
                  isActive ? "bg-secondary text-primary" : "text-foreground hover:bg-secondary/60"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            type="button"
            data-testid="mobile-menu-button"
            aria-expanded={open}
            aria-controls="mobile-nav"
            aria-label={open ? "Close menu" : "Open menu"}
            onClick={() => setOpen((v) => !v)}
            className="inline-flex min-h-[44px] min-w-[44px] items-center justify-center rounded-full border border-border text-primary lg:hidden"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <nav id="mobile-nav" aria-label="Mobile navigation" className="border-t border-border bg-background lg:hidden">
          <ul className="space-y-1 px-6 py-4">
            {NAV.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  data-testid={`mobile-nav-${item.to === "/" ? "home" : item.to.slice(1)}`}
                  className={({ isActive }) =>
                    `block rounded-xl px-4 py-3.5 text-lg font-medium ${
                      isActive ? "bg-secondary text-primary" : "text-foreground"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
            <li className="pb-2 pt-3">
              <BookingCta location="mobile_menu" testid="mobile-request-appointment" className="btn-primary w-full" />
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
}
